<template>
    <b-row>
        <b-col md="4">
            <indicator-card-work-schedule-statement
                ref="chartPosGold"
                :title="i18nPosGold"
                :busy="loading"
                :value="posGold"
                type="percentage"
                color="blue"
                :text-pos-active="i18nTextPosActive"
                :text-pos-schedule="i18nTextPosSchedule"
                :pos-active-count="posGoldTotal"
                :pos-schedule-count="posGoldWithStatement"
            />
        </b-col>
        <b-col md="4">
            <indicator-card-work-schedule-statement
                ref="chartPosSilver"
                :title="i18nPosSilver"
                :busy="loading"
                :value="posSilver"
                type="percentage"
                color="blue"
                :text-pos-active="i18nTextPosActive"
                :text-pos-schedule="i18nTextPosSchedule"
                :pos-active-count="posSilverTotal"
                :pos-schedule-count="posSilverWithStatement"
            />
        </b-col>
        <b-col md="4">
            <indicator-card-work-schedule-statement
                ref="chartPosBronze"
                :title="i18nPosBronze"
                :busy="loading"
                :value="posBronze"
                type="percentage"
                color="blue"
                :text-pos-active="i18nTextPosActive"
                :text-pos-schedule="i18nTextPosSchedule"
                :pos-active-count="posBronzeTotal"
                :pos-schedule-count="posBronzeWithStatement"
            />
        </b-col>
    </b-row>
</template>

<script>
    import WorkScheduleStatementService from '@/src/services/dashboards/widgets/WorkScheduleStatementService'
    import swalFeedback from '@src/mixins/swalFeedback.vue'
    import validationMixin from '@src/mixins/validation.vue'
    import IndicatorCardWorkScheduleStatement from '@/src/components/dashboards/IndicatorCardWorkScheduleStatement'

    const i18nKey = 'DASHBOARDS'

    export default {
        components: {
            IndicatorCardWorkScheduleStatement,
        },
        mixins: [
            validationMixin,
            swalFeedback,
        ],
        data() {
            return {
                i18nKey,
                loading: false,
                posGold: 0,
                posSilver: 0,
                posBronze: 0,
                posGoldActive: 0,
                posGoldWithStatement: 0,
                posSilverActive: 0,
                posSilverWithStatement: 0,
                posBronzeActive: 0,
                posBronzeWithStatement: 0,
                posGoldTotal: 0,
                posSilverTotal: 0,
                posBronzeTotal: 0,
            }
        },
        validations: {},
        computed: {
            i18nPosGold() {
                return this.getI18n(i18nKey, 'TITLES.pos_gold')
            },
            i18nPosSilver() {
                return this.getI18n(i18nKey, 'TITLES.pos_silver')
            },
            i18nPosBronze() {
                return this.getI18n(i18nKey, 'TITLES.pos_bronze')
            },
            i18nTextPosActive() {
                return this.getI18n(i18nKey, 'TITLES.pos_total_registered')
            },
            i18nTextPosSchedule() {
                return this.getI18n(i18nKey, 'TITLES.pos_with_schedule_total')
            },
        },
        methods: {
            refresh(parameters) {
                this.loading = true
                this.posGold = 0
                this.posSilver = 0
                this.posBronze = 0
                this.posGoldActive = 0
                this.posGoldWithStatement = 0
                this.posSilverActive = 0
                this.posSilverWithStatement = 0
                this.posBronzeActive = 0
                this.posBronzeWithStatement = 0
                this.posGoldTotal = 0
                this.posSilverTotal = 0
                this.posBronzeTotal = 0

                WorkScheduleStatementService.resume(parameters)
                    .then((response) => {
                        const d = response.data.data || {}
                        this.posGold = d.pos_gold_pct ?? 0
                        this.posSilver = d.pos_silver_pct ?? 0
                        this.posBronze = d.pos_bronze_pct ?? 0
                        this.posGoldActive = d.pos_gold_active ?? 0
                        this.posGoldWithStatement = d.pos_gold_with_statement ?? 0
                        this.posSilverActive = d.pos_silver_active ?? 0
                        this.posSilverWithStatement = d.pos_silver_with_statement ?? 0
                        this.posBronzeActive = d.pos_bronze_active ?? 0
                        this.posBronzeWithStatement = d.pos_bronze_with_statement ?? 0
                        this.posGoldTotal = d.pos_gold_total ?? 0
                        this.posSilverTotal = d.pos_silver_total ?? 0
                        this.posBronzeTotal = d.pos_bronze_total ?? 0
                        this.loading = false
                    })
                    .catch((err) => {
                        this.loading = false
                        return err
                    })
            },
        },
    }
</script>
